import { connect } from 'react-redux';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

import ViewOfficeHours from './components/ViewOfficeHours';

const OfficeSessionsQuery = gql`
query {
  getOfficeSessions2 {
    id
    start_time
    end_time
    title
    company_1
    company_2
    advisor_bio
    host {
      first_name
      last_name
      photo
    }
  }
}
`;

const RegisterSessionMutation = gql`
mutation (
  $SessionId: Int!
  $UserEmail: String!
  $TrackUrl: String!
  $UtmSource: String
  $UtmMedium: String
  $UtmCampaign: String
  $UtmTerm: String
  $UtmContent: String
  $AnonId: String
) {
  RSVPForOfficeHourSession(
    SessionID: $SessionId
    userEmail: $UserEmail
    trackUrl: $TrackUrl
    utmSource: $UtmSource
    utmMedium: $UtmMedium
    utmCampaign: $UtmCampaign
    utmTerm: $UtmTerm
    utmContent: $UtmContent
    anonId: $AnonId
  ) {
    id
  }
}
`;

const SendEmailMutation = gql`
mutation (
  $SendArray: [String]!
  $Email: String!
  $Name: String!
  $Message: String
  $AnonId: String
) {
  ShareOfficeHourEmail(
    SendTo: $SendArray
    Email: $Email
    Name: $Name
    Message: $Message
    AnonId: $AnonId
  ) {
    status
  }
}
`;

export default (store) => ({
  component:  compose(
    graphql(OfficeSessionsQuery, {
      name: 'SessionData',
    }),
    graphql(RegisterSessionMutation, {
      name: 'RegisterSession'
    }),
    graphql(SendEmailMutation, {
      name: 'SendEmailInvite'
    })
  )(ViewOfficeHours),
});



// WEBPACK FOOTER //
// ./src/routes/officehours-v2/routes/ViewOfficeHours/index.js